
import { computed, defineComponent, PropType, reactive, ref, watch } from 'vue'
import InputSelectHorizontal from '@/components/inputs/InputSelectHorizontal.vue'
import InputCheck from '@/components/inputs/InputCheck.vue'
import InputTime from '@/components/inputs/InputTime.vue'

import { store } from '@/store'
import { Route, RouteSettings } from '@/api/tripply/models'
import { compareObjects } from '@/api/tools'

export default defineComponent({
  name: 'RouteSettings',
  components: { InputSelectHorizontal, InputCheck, InputTime },
  props: {
    route: {
      type: Object as PropType<Route>,
      required: true    
    }
  },
  setup(props) {
    const settings = reactive<RouteSettings>({ ...props.route.settings })
    settings.breakTime /= 60
    settings.timeLimit /= 3600

    const breaks = ref(
      settings.timeLimit > 0 ? 'auto' :
      settings.breakTime > 0 ? 'fixed' : 'none'
    )

    const minTimeLimit = computed(() => Math.ceil(props.route.durationDriving / 60 / 60))

    async function update() {
      const updatedSettings = {...settings}
      updatedSettings.breakTime *= 60
      updatedSettings.timeLimit *= 3600
      if (breaks.value == 'fixed') updatedSettings.timeLimit = 0
      if (breaks.value == 'none') {
        updatedSettings.timeLimit = 0
        updatedSettings.breakTime = 0
      } 
      const changes = compareObjects<RouteSettings>(props.route.settings, updatedSettings)
      store.route.updateSettings(props.route.id, changes)
    }

    watch(breaks, (type) => {
      if (type == 'auto' && settings.timeLimit == 0) {
        settings.timeLimit = minTimeLimit.value
      } 
      update()
    })

    watch(settings, () => {
      update()
    })

    function close() {
      store.ui.mutate(state => state.route.settingsDrawer = false)
    }

    return { settings, close, breaks, minTimeLimit }
  }
})
